<template>
    <modal
        :active="active"
        :large="true"
        :title="title()"
        @closed="close"
    >
        <div class="columns is-tablet">
            <div class="column">
            <form-field
                :error="error.count"
                class="column"
                label="Note"
            >
                <InputTextarea v-model="form.note" rows="8" />
            </form-field>
            </div>
        </div>

        <div v-if="customer.note" class="columns is-tablet">
            <div class="column">
                <form-field
                    :error="error.count"
                    class="column"
                    label="Opdateret af"
                >
                    <InputText :value="customer.note_user.name" disabled />
                </form-field>
            </div>
            <div class="column">
                <form-field
                    :error="error.count"
                    class="column"
                    label="Opdateret d."
                >
                    <InputText :value="customer.note_updated_at | humanDateTime" disabled />
                </form-field>
            </div>
        </div>

        <template v-slot:footer class="has-space-between">
            <div class="footer-spacer">
                <div>
                    <button v-if="customer.note" class="button is-danger is-flex-left" @click="deleteNote">Slet</button>
                    <button class="button is-default" @click="close">Annuller</button>
                    <button class="button is-primary" @click="save">{{ customer.note ? 'Gem' : 'Opret' }}</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import {FormField, InputTextarea, InputText} from '@elems/form'
import humanDateTime from "../../filters/humanDateTime";

export default {
    components: {
        Modal,
        FormField,
        InputTextarea,
        InputText
    },
    filters: {
        humanDateTime,
    },
    props: {
        active: Boolean,
        customer: Object,
    },
    data() {
        return {
            form: {
                note: '',
            },
            error: [],
        }
    },
    watch: {
        active() {
            if (this.active) {
                this.form.note = this.customer.note
            }
        }
    },
    methods: {
        formatDate(value) {
            return moment(value).format('DD/MM-YYYY HH:mm:ss');
        },
        close() {
            this.$emit('closed');
        },
        save() {
            this.$emit('updated');
        },
        title() {
            return this.customer.note ? 'Rediger intern note' : 'Opret intern note';
        },
        save() {
            if (this.customer.note === this.form.note) {
                this.$emit('closed');
                return;
            }

            window.axios.post(`/api/customers/${this.customer.id}/note`, this.form)
                .then(({ data }) => {
                    this.$store.dispatch('setSuccess', 'Intern note blev opdateret')
                    this.$emit('updated', data)
                    this.$emit('closed')
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.error = error.response.data.errors
                    }
                });
        },
        deleteNote() {
            if (!confirm('Er du sikker på du vil slette den interne note?')) {
                return
            }

            this.form.note = '';
            this.save();
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
